import AccountMarketingMaterialEventTableTentTemplate from './AccountMarketingMaterialEventTableTentTemplate';

export default AccountMarketingMaterialEventTableTentTemplate;
